import request from '@/utils/request'

let Print_tempApi = {

  /*打印机模板列表*/
  list(data) {
    return request._post('/shop/plus.print_temp.Index/index', data);
},
/*添加打印机模板*/
add(data) {
    return request._post('/shop/plus.print_temp.Index/add', data);
},
/*修改打印机模板*/
edit(data) {
    return request._post('/shop/plus.print_temp.Index/edit', data);
},
/*删除打印机模板*/
del(data) {
    return request._post('/shop/plus.print_temp.Index/del', data);
},
/*打印机模板详情*/
detail(data) {
  return request._post('/shop/plus.print_temp.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.print_temp.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.print_temp.Setting/getSetting', data, errorback);
    },
    copy(data) {
        return request._post('/shop/plus.print_temp.Index/copy', data);
    },
     editPart(data) {
            return request._post('/shop/plus.print_temp.Index/editPart', data);
        },
}
export default Print_tempApi;



// WEBPACK FOOTER //
// ./src/api/print_temp.js